'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.default = Icon;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _propTypesElementtype = require('prop-types-elementtype');

var _propTypesElementtype2 = _interopRequireDefault(_propTypesElementtype);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _reactProptypeConditionalRequire = require('react-proptype-conditional-require');

var _reactProptypeConditionalRequire2 = _interopRequireDefault(_reactProptypeConditionalRequire);

var _Box = require('@deliveroo/icon-set/react/Box');

var _Box2 = _interopRequireDefault(_Box);

var _mergeProps = require('../../utils/mergeProps');

var _mergeProps2 = _interopRequireDefault(_mergeProps);

var _SpacerElement = require('../../internal/SpacerElement');

var _SpacerElement2 = _interopRequireDefault(_SpacerElement);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var styles = {
  'wrapper': 'ccl-462400680c526774',
  'icon': 'ccl-0f24ac4b87ce1f67',
  'black': 'ccl-bf4f7cc9f711ee74',
  'green': 'ccl-b86ddb4586c18dbc',
  'grey': 'ccl-94235a1794a6d4be',
  'light-grey': 'ccl-1e6f880f67285c2e',
  'orange': 'ccl-1afda83b74457cf5',
  'red': 'ccl-efcd3c7c5ed8241a',
  'teal': 'ccl-0f084ffde1637b39',
  'white': 'ccl-be253fe60aa767f4',
  'size18': 'ccl-cd43b511fc3197b8',
  'size24': 'ccl-6e6795ea503c9f83',
  'size36': 'ccl-e1d4e08a1e2a9bf8',
  'size48': 'ccl-450d659ff0c36831',
  'placeholder': 'ccl-bac03c79fb9f4f0d'
};


var COLORS = ['black', 'green', 'grey', 'light-grey', 'orange', 'red', 'teal', 'white'];

/**
 * A component to render an SVG icon, taken from the Product Design System icon
 * set. Note that you will also need to include the dependency supplying the
 * specific icon you want to use directly from the `@deliveroo/icon-set`
 * package. You can see a full list of all the available icons on the
 * [`IconWithText`](/component/IconWithText) component.
 */
function Icon(originalProps) {
  var isPlaceholder = originalProps.isPlaceholder;

  var props = isPlaceholder ? (0, _mergeProps2.default)(originalProps, Icon.placeholderProps) : originalProps;
  var size = props.size,
      color = props.color,
      IconComponent = props.component,
      spacing = props.spacing,
      adjacentVerticalSpacing = props.adjacentVerticalSpacing,
      adjacentHorizontalSpacing = props.adjacentHorizontalSpacing;


  var sizeClass = styles['size' + size];
  var colorClass = COLORS.includes(color) && styles[color];
  var wrapperClasses = (0, _classnames2.default)(styles.wrapper, sizeClass);
  var iconClasses = (0, _classnames2.default)(styles.icon, sizeClass, colorClass);

  // Don’t render anything if no IconComponent was supplied
  if (!IconComponent) return null;

  return _react2.default.createElement(
    _SpacerElement2.default,
    {
      element: 'span',
      spacing: spacing,
      className: wrapperClasses,
      adjacentVerticalSpacing: adjacentVerticalSpacing,
      adjacentHorizontalSpacing: adjacentHorizontalSpacing,
      isPlaceholder: isPlaceholder,
      placeholderClassName: styles.placeholder
    },
    _react2.default.createElement(IconComponent, { className: iconClasses, viewBox: '0 0 24 24' })
  );
}

Icon.displayName = 'Icon';
Icon.propTypes = _extends({
  /**
   * The icon component you'd like to render, taken from `@deliveroo/icon-set`.
   * Note that you will also need to include this component as a dependency,
   * e.g. `import Acorn from '@deliveroo/icon-set/react/Acorn';`
   */
  component: (0, _reactProptypeConditionalRequire2.default)(_propTypesElementtype2.default, function (props) {
    return !props.isPlaceholder;
  }),

  /**
   * The size of the icon.
   */
  size: _propTypes2.default.oneOf([18, 24, 36, 48]),

  /**
   * An explicit icon colour, overriding the inherited parent colour.
   */
  color: _propTypes2.default.oneOf(COLORS)

}, _SpacerElement2.default.propTypes);

Icon.defaultProps = _extends({
  size: 24,
  color: undefined
}, _SpacerElement2.default.defaultProps);

Icon.placeholderProps = {
  size: 24,
  component: _Box2.default
};